import React, { Component } from "react";
import { connect } from "react-redux";

//Comps
import UserProfile from "./account_tabs/Profile";
import UserSettings from "./account_tabs/Settings";

//Deps
import { withStyles } from "@material-ui/core/styles";

import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";

function mapStateToProps(state) {
  return {
    clientKey: state.user.currentUser.clientKey,
    email: state.user.currentUser.email,
    name: state.user.currentUser.name,
    users: state.user.currentUser.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Tab container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: "1em" }}>
      {props.children}
    </Typography>
  );
}

//Styles
const styles = theme => ({
  root: {},
  paper: {
    width: "100%",
    paddingTop: "1em"
  },
  icon: {
    paddingBottom: "10px"
  },
  container: {
    padding: "1em"
  }
});

class UserAccountPage extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            fullWidth
            indicatorColor="secondary"
            textColor="secondary">
            <Tab icon={<PersonIcon />} className={classes.icon} />
            <Tab icon={<SettingsIcon />} className={classes.icon} />
          </Tabs>
        </Paper>
        <div className={classes.container}>
          {this.state.value === 0 && (
            <TabContainer>
              <UserProfile />
            </TabContainer>
          )}
          {this.state.value === 1 && (
            <TabContainer>
              <UserSettings />
            </TabContainer>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UserAccountPage));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/UserAccountPage.js